module.exports = __webpack_public_path__ + "img/Vectorconnect.0ab6798a.svg";